export type PlayAdviceStatus =
  | 'pending'
  | 'recommended'
  | 'near-equal'
  | 'forced'
  | 'cancelled'
  | 'unavailable';

export interface PlayAdvice {
  status: PlayAdviceStatus;
  message: string;
  transitionId?: string;
  candidateCount?: number;
  deadlineExceeded?: boolean;
}

export const PLAY_ADVICE_PENDING: PlayAdvice = {
  status: 'pending',
  message: 'Analyzing the legal plays…',
};

export const PLAY_ADVICE_CANCELLED: PlayAdvice = {
  status: 'cancelled',
  message: 'Analysis cancelled.',
};

export const PLAY_ADVICE_UNAVAILABLE: PlayAdvice = {
  status: 'unavailable',
  message: 'Advice is unavailable right now. Legal-move guidance remains active.',
};
